"use client";
import Loader from "@/components/Loader/Loader";
import { selectCartItems } from "@/redux/features/cartSlice";
import axiosInstance from "@/service/axiosInstance";
import { formatRegistrationDates } from "@/utils/utils";
import Image from "next/image";
import { useParams } from "next/navigation";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CommonBanner from "../listing-details-common/CommonBanner";
import CommonPropertyOverview from "../listing-details-common/CommonPropertyOverview";
import MediaGallery from "./MediaGallery";

import Calender from "@/assets/images/icon/calender.svg";

const ListingDetailsOneArea = () => {
  const searchParams = useParams();
  const id = searchParams.slug[1];

  const cart = useSelector(selectCartItems);
  const [data, setData] = useState<any>(null);
  const [count, setCount] = useState(0);
  const [exists, setExists] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const fetchData = async () => {
    try {
      setLoading(true);
      const resp: any = await axiosInstance.get(`/events/${id}`);

      // const data: any = await getData(); // Wait for the promise to resolve
      let matchingCartItem: any;
      const updatedData: any = (resp: any) => {
        matchingCartItem = cart.find((val: any) => val?.id === resp?.id);
        return {
          ...resp,
          inCart: matchingCartItem ? matchingCartItem.inCart : 0,
        };
      };
      const update = updatedData(resp);
      setLoading(false);
      setData(update);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const convertToEmbededURL = (url: string) => {
    const regExp =
      /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    const videoId = match && match[2].length === 11 ? match[2] : null;
    return `https://www.youtube.com/embed/${videoId}`;
  };

  useEffect(() => {
    if (id) {
      fetchData();
    }
  }, []);

  return (
    <>
      {loading && <Loader />}
      {data && (
        <div>
          <CommonBanner data={data} count={count} exists={exists} />
          {!data.attributes?.is_private ? (
            <div
              className=" bg-white shadow4 border-20 my-2"
              style={{ padding: "10px", borderRadius: "20px" }}
            >
              <CommonPropertyOverview data={data} />
            </div>
          ) : (
            <div className="my-4 d-flex align-items-center gap-3">
              <Image
                src={Calender}
                alt="calender logo"
                style={{ width: "1.8rem" }}
              />
              <span>
                Registration dates :{" "}
                {formatRegistrationDates(
                  data.attributes.event_register_start_date,
                  data.attributes.event_register_end_date,
                )}
              </span>
            </div>
          )}
          {!data.attributes?.is_private && (
            <>
              <div>
                {data?.attributes?.live_streaming_link && (
                  <>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <iframe
                        src={convertToEmbededURL(
                          data.attributes.live_streaming_link,
                        )}
                        title="Live Video Player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                        style={{
                          width: "100%",
                          height: "auto",
                          aspectRatio: "16/9",
                        }}
                      ></iframe>
                    </div>
                  </>
                )}
              </div>
              <MediaGallery data={data} />
            </>
          )}
        </div>
      )}
    </>
  );
};

export default ListingDetailsOneArea;
